export function Spinner({ label = "Loading" }: { label?: string }) {
  return (
    <span className="btn__spinner" role="status" aria-label={label} />
  );
}

export function FullPageSpinner() {
  return (
    <div
      style={{
        flex: 1,
        display: "grid",
        placeItems: "center",
        padding: "var(--s-9)",
        color: "var(--fg-subtle)",
      }}
    >
      <Spinner label="Loading page" />
    </div>
  );
}

export function SkeletonRows({ rows = 5 }: { rows?: number }) {
  return (
    <div className="stack" style={{ ["--flow" as string]: "var(--s-3)" }}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skeleton" style={{ height: "2.5rem", width: `${100 - i * 4}%` }} />
      ))}
    </div>
  );
}
